import React from "react";

function NetWorkBalance() {
  return (
    <div className="flex justify-between text-xs">
      <p>Network</p>
      <p className="pr-12">Balance</p>
    </div>
  );
}

export default NetWorkBalance;
